import React from "react";
import "./FullPageLoader.css";

const FullPageLoader = ({ message = "Processing..." }) => {
  return (
    <div className="full-page-loader-overlay">
      <div className="full-page-loader-content">
        <div className="loader-container">
          <div className="ee-logo-spinner-lg" />
        </div>
        <div className="loader-text">
          <h3>{message}</h3>
          <p>Please wait while we process your request</p>
        </div>
      </div>
    </div>
  );
};

export default FullPageLoader;

